import React, { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import useNotificationStore from '../../../common/store/NotificationStore'

const NotificationMediator = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { undisplayedNotifications, removeNotification, markAsDisplayed } = useNotificationStore();

    useEffect(() => {
        if (undisplayedNotifications.length > 0){
            console.log(`useEffect - notifications > 0 : ${undisplayedNotifications.length}`)
            const notification = undisplayedNotifications[0];
            enqueueSnackbar(notification.message, { variant: notification.severity, onClose: () => removeNotification(notification.key) });
            markAsDisplayed(notification.key);
        }
    }, [undisplayedNotifications, enqueueSnackbar, removeNotification, markAsDisplayed])

    return (<></>)
};

export default NotificationMediator;
